// icon:notebook | Tabler Icons https://tablericons.com/ | Csaba Kissi
import * as React from "react";

function IconNotebook(props) {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
      height="1em"
      width="1em"
      {...props}
    >
      <path stroke="none" d="M0 0h24v24H0z" />
      <path d="M6 4h11a2 2 0 012 2v12a2 2 0 01-2 2H6a1 1 0 01-1-1V5a1 1 0 011-1m3 0v18M13 8h2M13 12h2" />
    </svg>
  );
}

export default IconNotebook;
